import { PanelRight } from "lucide-react";
import type { FC } from "react";

import { HeaderIconButton } from "@/components/app-header";

import { caseyShortcutKeys, caseyShortcutLabel } from "../layout/caseyShortcut";
import { ideLayoutStore, useIdeLayout } from "../layout/ideLayoutStore";

/** The header's Casey toggle, the files toggle's mirror at the bar's right end. */
export const CaseyToggle: FC = () => {
  const ide = useIdeLayout();
  const hidden = ide.collapsed.right;
  return (
    <HeaderIconButton
      label={`${
        hidden ? "Show Casey" : "Hide Casey"
      } (${caseyShortcutLabel()})`}
      aria-keyshortcuts={caseyShortcutKeys()}
      pressed={!hidden}
      onClick={() => ideLayoutStore.toggle("right")}
    >
      <PanelRight className="size-4" />
    </HeaderIconButton>
  );
};
